"use client"

import { useQuery } from "@tanstack/react-query"
import { getAiDisclosureSettingsAction } from "@/server-actions/ai-disclosure-settings"
import { usePermissions } from "@/hooks/use-permissions"
import { useAuth } from "@/hooks/use-auth"
import { TENANTS_PERMISSIONS } from "@/lib/auth/permissions.constants"

export const aiDisclosureSettingsQueryPrefix = ["organization", "ai-disclosure"] as const

export function useAiDisclosureSettingsQuery() {
  const { activeTenantId, can } = usePermissions()
  const { isAuthenticated } = useAuth()
  return useQuery({
    queryKey: [...aiDisclosureSettingsQueryPrefix, activeTenantId],
    enabled: isAuthenticated && Boolean(activeTenantId) && can([
      TENANTS_PERMISSIONS.VIEW_OWN,
      TENANTS_PERMISSIONS.EDIT_OWN,
    ]),
    queryFn: async () => {
      const result = await getAiDisclosureSettingsAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
